export default [
  {
    path: '/coinsHist',
    name: 'coinsHist',
    component: () => import('@views/coins/coinsHist.vue'),
    meta: {
      title: '邀工币-历史记录'
    }
  },
  {
    path: '/coinsRecharge',
    name: 'coinsRecharge',
    component: () => import('@views/coins/coinsRecharge.vue'),
    meta: {
      title: '邀工币-充值'
    }
  },
  {
    path: '/coinsPay',
    name: 'coinsPay',
    component: () => import('@views/coins/coinsPay.vue'),
    meta: {
      title: '邀工币-缴费'
    }
  },
  {
    path: '/coinsInvitation',
    name: 'coinsInvitation',
    component: () => import('@views/coins/invitation.vue'),
    meta: {
      title: '邀工币-缴费'
    }
  },
  {
    path: '/shareInfo',
    name: 'shareInfo',
    component: () => import('@views/coins/shareInfo.vue'),
    meta: {
      title: '分享详情页'
    }
  },
  {
    path: '/topInfo',
    name: 'shareTopInfo',
    component: () => import('@views/coins/shareTopInfo.vue'),
    meta: {
      title: '分享详情页'
    }
  },
  {
    path: '/top',
    name: 'top',
    component: () => import('@views/coins/top.vue'),
    meta: {
      title: '置顶页面'
    }
  },
  {
    path: '/inviteFriends',
    name: 'inviteFriends',
    component: () => import('@views/coins/inviteFriends.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/inviteList',
    name: 'inviteList',
    component: () => import('@views/coins/inviteList.vue'),
    meta: {
      title: '邀请好友'
    }
  }
]
